import {Component, ComponentRef, Injector, Type, ViewChild, ViewContainerRef} from '@angular/core';

@Component({
    standalone: true,
    template: `
        <ng-template #anchor></ng-template>
        `,
    styles: [':host{display: block; height: 0; overflow: hidden;}']
})
export class ContainerComponent {
    @ViewChild('anchor', {read: ViewContainerRef, static: true})
    public anchor: ViewContainerRef;
    public appendComponent<T>($component: Type<T>, $injector?: Injector): ComponentRef<T> {
        if ($injector) {
            return this.anchor.createComponent($component, {
                injector: $injector
            })
        }
        return this.anchor.createComponent($component);
    }

    public remove($index?: number): void {
        this.anchor.remove($index);
    }
}
